import { EmailsActionTypes } from './constants';

const INIT_STATE = {
    data: null,
    loading: false,
    error: null,
    updateSuccess: null,
};

const Emails = (state = INIT_STATE, action) => {
    switch (action.type) {
        case EmailsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case EmailsActionTypes.GET_EMAILS:
                    return { ...state, data: action.payload.data, loading: false };
                case EmailsActionTypes.GET_EMAIL_BY_ID:
                    return { ...state, data: action.payload.data, loading: false };
                case EmailsActionTypes.GET_EMAILS_BY_USER:
                    return { ...state, data: action.payload.data, loading: false };
                case EmailsActionTypes.GET_EMAILS_BY_TRANSACTION:
                    return { ...state, data: action.payload.data, loading: false };
                case EmailsActionTypes.CREATE_EMAIL:
                    return {
                        ...state,
                        id: action.payload.id,
                        data: action.payload.data,
                        loading: false,
                        updateSuccess: true,
                    };
                case EmailsActionTypes.UPDATE_EMAIL:
                    return {
                        ...state,
                        id: action.payload.id,
                        data: action.payload.data,
                        loading: false,
                        updateSuccess: true,
                    };
                case EmailsActionTypes.DELETE_EMAIL:
                    return { ...state, data: action.payload.data, loading: false };
                case EmailsActionTypes.ARCHIVE_EMAIL:
                    return { ...state, data: action.payload.data, loading: false };
                case EmailsActionTypes.CREATE_ATTACHMENT:
                    return {
                        ...state,
                        id: action.payload.id,
                        data: action.payload.data,
                        loading: false,
                        updateSuccess: true,
                    };
                default:
                    return { ...state };
            }
        case EmailsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case EmailsActionTypes.GET_EMAILS:
                    return { ...state, error: action.payload, loading: false };
                case EmailsActionTypes.GET_EMAIL_BY_ID:
                    return { ...state, error: action.payload, loading: false };
                case EmailsActionTypes.GET_EMAILS_BY_USER:
                    return { ...state, error: action.payload, loading: false };
                case EmailsActionTypes.GET_EMAILS_BY_TRANSACTION:
                    return { ...state, error: action.payload, loading: false };
                case EmailsActionTypes.CREATE_EMAIL:
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };
                case EmailsActionTypes.UPDATE_EMAIL:
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };
                case EmailsActionTypes.DELETE_EMAIL:
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };
                case EmailsActionTypes.ARCHIVE_EMAIL:
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };
                case EmailsActionTypes.CREATE_ATTACHMENT:
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };
                default:
                    return { ...state };
            }
        // Get Emails
        case EmailsActionTypes.GET_EMAILS:
            return { ...state, loading: true };
        // Get a single message
        case EmailsActionTypes.GET_EMAIL_BY_ID:
            return { ...state, data: null, loading: true };
        // Get an offer by ID
        case EmailsActionTypes.GET_EMAILS_BY_USER:
            return { ...state, data: null, loading: true };
        case EmailsActionTypes.GET_EMAILS_BY_TRANSACTION:
            return { ...state, data: null, loading: true };
        // Submit a new offer
        case EmailsActionTypes.UPDATE_EMAIL: {
            return { ...state, id: action.payload.id, data: action.payload.data, loading: false };
        }
        case EmailsActionTypes.CREATE_EMAIL:
            return { ...state, data: null, loading: true, updateSuccess: false };
        case EmailsActionTypes.RESET_EMAILS:
            return INIT_STATE;
        default:
            return { ...state };
    }
};

export default Emails;
